import React from 'react';
import { HomefieldIconPlArrowRight, HomefieldIconPlIcon } from '@dsg-tech/homefield-react-icons';
import { checkStores, setDataEmTag } from '../../../../utility/utility';
import { CTA, StoreIdentifierName } from '../../../../types';
import './TopMessage.scss';

type Props = {
  topMessageData: CTA[];
  storeIdentifierName: StoreIdentifierName;
};

export default function TopMessage({ topMessageData, storeIdentifierName }: Props) {
  return (
    <div className="topMessage-container hmf-ml-m-xs hmf-p-xs hmf-p-m-0">
      {storeIdentifierName === 'pl' && (
        <HomefieldIconPlIcon
          className="topMessage-container--icon hmf-pr-xxs"
          width="25px"
          height="20px"
        />
      )}
      {topMessageData?.map((links: CTA) => (
        <a
          key={`link-${links.linkTitle}`}
          href={checkStores(links.link)}
          data-em={setDataEmTag('Header', links.linkTitle)}
          className="topMessage-container--links hmf-subheader-bold-m"
          title={links.linkTitle}>
          {links.linkTitle}
        </a>
      ))}
      <HomefieldIconPlArrowRight
        className="topMessage-container--arrow"
        width="50px"
        height="12px"
      />
    </div>
  );
}
